import { Component } from 'react';

type StateType = {
  currentStep?: number;
}

export type FlowType = {
  element: React.ReactNode;
  skipCondition?: () => boolean;
  onNext?: () => void;
}

type PropType = {
  steps: FlowType[];
}

export default class Flow extends Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props);
    this.state = {
      currentStep: undefined,
    };
  }

  start(step?: number): void {
    this.setState({ currentStep: step || 0 });
  }

  async next(): Promise<void> {
    const { steps } = this.props;
    const numSteps = steps.length;
    const { currentStep } = this.state;

    if (currentStep === undefined) {
      throw new Error('Start flow before calling next');
    }

    const currentItem = steps[currentStep];
    if (currentItem.onNext) {
      await currentItem.onNext();
    }

    let nextStep = currentStep + 1;
    while (nextStep < numSteps) {
      const nextItem = steps[nextStep];

      if (!nextItem.skipCondition || !nextItem.skipCondition()) {
        this.setState({ currentStep: nextStep });
        return;
      }
      if (nextItem.onNext) {
        await nextItem.onNext(); // eslint-disable-line
      }
      nextStep += 1;
    }
    this.stop();
  }

  stop(): void {
    this.setState({ currentStep: undefined });
  }

  render(): React.ReactNode {
    const { steps } = this.props;
    const { currentStep } = this.state;
    if (currentStep === undefined) {
      return false;
    }
    return steps[currentStep].element;
  }
}
